// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseGradingData } from './genericApiResponseGradingData';
import type { GenericApiResponseGradingMessage } from './genericApiResponseGradingMessage';
import type { GenericApiResponseGradingPagination } from './genericApiResponseGradingPagination';
import type { GenericApiResponseGradingError } from './genericApiResponseGradingError';

export interface GenericApiResponseGrading {
  data?: GenericApiResponseGradingData;
  message?: GenericApiResponseGradingMessage;
  pagination?: GenericApiResponseGradingPagination;
  error?: GenericApiResponseGradingError;
  statusCode?: number;
}
